export const createRateString = (budget: unknown) =>
  Number(budget) ? `$${budget}/hr` : null;
